<template src="./index.html"></template>
<script>
import minhead from '../../../../common/minHead/index.vue';
import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
import { getdata } from './data.js';
import config from '../../../../../../configHttp.js';
import uploadFile from '../../../../common/uploadFile/index.vue';
import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
import {
    querycell,
    writesave,
    startShenBao,
    forShengcdg,
    manuscriptqueryReportStep,
    manuscriptwriteimport,
    manuscriptUploadFile,
    annexadd
} from '../../../../../api/Draftgeneration.js';
import { querytemplatecell, getShuibDetailList, templatecellsave } from '../../../../../api/bbmb.js';
import { reportquerytrack } from '../../../../../api/xggj.js';
import { zcfg_fycx, zcfg_fetch } from '../../../../../api/zcfg.js';
import addzc from '../../../../common/addzc/index.vue';
import seezc from '../../../../common/seezc/index.vue';
import corporateIncomeTax_I from './corporateIncomeTax_I/index.vue';
import { getdata as getdataI } from './corporateIncomeTax_I/data.js';
import corporateIncomeTax_II from './corporateIncomeTax_II/index.vue';
import { getdata as getdataII } from './corporateIncomeTax_II/data.js';
import corporateIncomeTax_III from './corporateIncomeTax_III/index.vue';
import { getdata as getdataIII } from './corporateIncomeTax_III/data.js';
import corporateIncomeTax_VI from './corporateIncomeTax_VI/index.vue';
import { getdata as getdataVI } from './corporateIncomeTax_VI/data.js';
import corporateIncomeTax_V from './corporateIncomeTax_V/index.vue';
import { getdata as getdataV } from './corporateIncomeTax_V/data.js';
export default {
    name: '',
    components: {
        minhead,
        SalesTaxReportTree,
        SalesTaxReportbox,
        uploadFile,
        uploadFileplus,
        addzc,
        seezc,
        corporateIncomeTax_I,
        corporateIncomeTax_II,
        corporateIncomeTax_III,
        corporateIncomeTax_VI,
        corporateIncomeTax_V
    },
    props: {
        type: {
            type: String,
            default: ''
        },
        params: {
            type: Object,
            default: {}
        },
        sbqj: {
            type: String,
            default: ''
        },
        showbox: {
            type: Boolean,
            default: false
        },
        mintext: {
            type: String,
            default: '填写'
        },
        toseeUpdate: {
            type: Boolean,
            default: false
        },
        seeNow: {
            type: Boolean,
            default: false
        },
        suosq: {
            type: String,
            default: ''
        }
    },
    mounted() {
        if (this.toseeUpdate) {
            this.getShuibDetailList();
        } else {
            this.manuscriptqueryReportStep();
        }
    },
    data: function () {
        return {
            treestate: '',
            statedata: [],
            treedata: getdata().treedata,
            choosetitleindex: '',
            formlist: getdata().formlist,
            headobj: {},
            choosecellCode: '',
            smtext: '',
            zcdata: [],
            Changed: 0,
            searchlistzc: getdata().searchlistzc,
            headDatazc: getdata().headDatazc,
            pagination: getdata().pagination,
            seezcformlist: getdata().seezcformlist,
            formdatazc: getdata().formdatazc, //form表单数据
            tableDataVI: [],
            //表一
            tableDataI: [],
            tableDataII: [],
            tableDatas: [],
            tableDatasv: [],
            tableDatasvi: [],
            tableDatasvii: [],
            IHead: [
                'sdsA_1_x_1',
                'sdsA_1_x_2',
                'sdsA_1_x_3',
                'sdsA_1_x_4',
                'sdsA_1_x_5',
                'sdsA_1_x_6',
                'sdsA_1_x_7',
                'sdsA_1_x_8',
                'sdsA_1_x_9'
            ],
            IIHead: ['sdsA_2_x_1', 'sdsA_2_x_2', 'sdsA_2_x_3', 'sdsA_2_x_4', 'sdsA_2_x_5', 'sdsA_2_x_6'],
            //表三
            tableDatavx: [],
            tableDataIII: [],
            IIIHead: [
                'sdsA_3_x_1',
                'sdsA_3_x_2',
                'sdsA_3_x_3',
                'sdsA_3_x_4',
                'sdsA_3_x_5',
                'sdsA_3_x_6',
                'sdsA_3_x_7',
                'sdsA_3_x_8',
                'sdsA_3_x_9',
                'sdsA_3_x_10'
            ],
            choosetable: '',
            chooseindex: '',
            choosecolum: '',
            delCellsI: [],
            delCellsIII: [],
            errdiag: false,
            errarr: []
        };
    },

    methods: {
        //政策点击预览
        zcsclick(id) {
            this.$refs.boxref.zcsclick(id);
        },
        //选中格子
        forhover(table, colum, index) {
            this.$refs.boxref.forhover(table, colum, index);
        },
        //获取选中格子
        getchoosecellCode(table, colum, index) {
            if (this.$emptyandnull(table)) {
                this.choosecellCode = '';
                return false;
            }
            this.choosetable = table;
            this.chooseindex = index;
            this.choosecolum = colum;
            if(!table||!table||!colum){
                return
            }
            this.choosecellCode = this[table][index][colum].cellCode;
            if (this.toseeUpdate) {
                this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
                this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
            } else {
                this.smtext = this[table][index][colum]['updateDesc'] || '';
            }
        },
        //更正说明
        forgengzheng(table, colum, index, smtext) {
            this[table][index][colum]['updateDesc'] = smtext;
        },
        //更正政策和说明
        forxzsm(table, colum, index, smtext, zcdata) {
            this[table][index][colum]['map'] = {
                desc: '',
                zcs: []
            };
            this[table][index][colum]['map']['desc'] = smtext;
            this[table][index][colum]['map']['zcs'] = zcdata;
        },
        //点击全部范围
        refreshhover() {
            this.$nextTick(() => {
                this.$refs.boxref.refreshhover();
            });
        },
        getShuibDetailList() {
            getShuibDetailList({
                shuizId: this.params.shuizId,
                id: this.params.shuibId
            }).then((res) => {
                if (res.data.code == 1) {
                    this.treedata = res.data.data;
                    if (this.treedata[0]) {
                        this.getchoosetitleindex(this.treedata[0]);
                    }
                    this.querycell();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        manuscriptqueryReportStep() {
            manuscriptqueryReportStep({
                id: this.params.id,
                sbbm: this.params.sbbm
            }).then((res) => {
                if (res.data.code == 1) {
                    this.statedata = res.data.data.statusHistory;
                    this.treedata = res.data.data.detail;
                    if (this.treedata[0]) {
                        this.getchoosetitleindex(this.treedata[0]);
                    }
                    this.querycell();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        getchoosetitleindex(item) {
            this.choosetitleindex = item.shuibNameCode;
        },
        //表格隐藏显示和返回
        forback() {
            if (this.Changed > 0) {
                this.$showConfirm({
                    message: '是否不保存当前修改?',
                    title: '您还未保存'
                }).then((res) => {
                    if (res == 'confirm') {
                        this.$emit('forback', true);
                    } else {
                        //取消
                    }
                });
            } else {
                this.$emit('forback', true);
            }
        },
        changestate(e) {
            this.treestate = e;
        },
        //传给后端值处理
        filternums(data, filterlist) {
            var newlist = [];
            filterlist.forEach((ytem) => {
                let newval = data.map((item) => {
                    if (
                        item[ytem] != undefined &&
                        item[ytem] != 'undefined' &&
                        this.$notemptyandnull(item[ytem]) &&
                        item[ytem].cellVal != '合计'
                    ) {
                        return item[ytem];
                    } else {
                        return 'x';
                    }
                });
                newlist = [...newlist, ...newval].filter((gtem) => gtem != 'x');
            });
            return newlist;
        },
        refreshtableDataI() {
            this.tableDataI.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatasvii.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatasvi.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatasv.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatas.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
        },
        refreshtableDataII() {
            this.tableDataII.forEach((item, index) => {
                this.IIHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
        },
        refreshtableDataIII() {
            this.tableDataIII.forEach((item, index) => {
                this.IIIHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatavx.forEach((item, index) => {
                this.IIIHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
        },
        commanddcrefresh(e) {
            this.Changed++;
            if (e == 'all') {
                Object.keys(this.headobj).map((key) => (this.headobj[key] = ''));
                this.refreshtableDataI();
                this.refreshtableDataIII();
                this.refreshtableDataII();
            }
        },
        //所有表格渲染
        querycell(index) {
            if (this.type == 'update') {
                querycell({
                    companyNo: this.params.companyNo, // 公司编号
                    id: this.params.id, //报表id
                    shuibId: this.params.shuibId, //税种id
                    sbbm: this.params.sbbm
                }).then((res) => {
                    let dataarr = res.data.data;
                    this.gettable(dataarr);
                });
            }
            if (this.type == 'tosee') {
                if (this.seeNow) {
                    querycell({
                        companyNo: this.params.companyNo, // 公司编号
                        id: this.params.id, //报表id
                        shuibId: this.params.shuibId, //税种id
                        sbbm: this.params.sbbm
                    }).then((res) => {
                        let dataarr = res.data.data;
                        this.gettable(dataarr);
                    });
                    return false;
                }
                if (this.toseeUpdate) {
                    querytemplatecell({
                        shuibId: this.params.shuibId,
                        id: this.params.id
                    }).then((res) => {
                        let dataarr = res.data.data;
                        this.gettable(dataarr);
                    });
                } else {
                    reportquerytrack({
                        companyNo: this.params.companyNo, // 公司编号
                        id: this.params.id, //报表id
                        shuibId: this.params.shuibId, //税种id
                        sbbm: this.params.sbbm,
                        trackId: this.params.trackId
                    }).then((res) => {
                        let dataarr = res.data.data;
                        this.gettable(dataarr);
                    });
                }
            }
        },

        gettable(dataarr) {
            this.headobj = dataarr.head;
            this.delCellsI = [];
            this.delCellsIII = [];
            //I
            //资产加速折旧、摊销(扣除)优惠明细表
            if (dataarr.sdsA_2) {
                var newtableDataII = dataarr.sdsA_2;
                var realtableDataII = getdataII().tableData;
                realtableDataII.forEach((item, index) => {
                    if (newtableDataII[index]) {
                        this.IIHead.forEach((gtem) => {
                            item[gtem] = newtableDataII[index][gtem];
                        });
                    }
                });
                this.tableDataII = realtableDataII;
            }
            //主表
            var newtableDataI = dataarr.sdsA_1.filter((item, index) => index < 2);
            var realtableDataI = getdataI().tableData;
            realtableDataI.forEach((item, index) => {
                if (newtableDataI[index]) {
                    this.IHead.forEach((gtem) => {
                        item[gtem] = newtableDataI[index][gtem];
                    });
                }
            });
            this.tableDataI = realtableDataI;

            var newtableDatas = dataarr.sdsA_1.filter((item, index) => index > 1 && index < 5);
            var realtableDatas = getdataI().tableDatas;
            realtableDatas.forEach((item, index) => {
                if (newtableDatas[index]) {
                    this.IHead.forEach((gtem) => {
                        item[gtem] = newtableDatas[index][gtem];
                        let sdsA_1_0d_1 = '';
                        if (
                            item[gtem] &&
                            item[gtem].cellCode.substring(item[gtem].cellCode.length, item[gtem].cellCode.length - 1) == '1'
                        ) {
                            if (item[gtem].cellVal == null || item[gtem].cellVal == '' || item[gtem].cellVal == '0') {
                                item[gtem].cellVal = 'N';
                            }
                            if (item[gtem].cellCod == 'sdsA_1_0d_1' && item[gtem].cellVal == 'N') {
                                sdsA_1_0d_1 = true;
                            }
                        } else if (
                            item[gtem] &&
                            item[gtem].cellCode.substring(item[gtem].cellCode.length, item[gtem].cellCode.length - 1) == '2'
                        ) {
                            if (item[gtem].sdsA_1_0e_2 && item[gtem].sdsA_1_0e_2 == '0') {
                                item[gtem].sdsA_1_0e_2 = '';
                            }
                            if (item[gtem].cellCod == 'sdsA_1_0d_2' && sdsA_1_0d_1) {
                                item[gtem].cellVal = '';
                            }
                        }
                    });
                }
            });
            this.tableDatas = realtableDatas;

            var newtableDatasv = dataarr.sdsA_1.filter((item, index) => index > 4 && parseFloat(item.hanh) < 17);
            var oldsv = getdataI().tableDatasv;
            var realtableDatasv = newtableDatasv;
            realtableDatasv.forEach((item, index) => {
                if (newtableDatasv[index]) {
                    this.IHead.forEach((gtem) => {
                        if (typeof newtableDatasv[index][gtem] != 'undefined' && typeof newtableDatasv[index][gtem] != undefined) {
                            if (
                                (parseFloat(newtableDatasv[index].hanh) > 13 && parseFloat(newtableDatasv[index].hanh) < 14) ||
                                (parseFloat(newtableDatasv[index].hanh) > 7 && parseFloat(newtableDatasv[index].hanh) < 8)
                            ) {
                                item['sdsA_1_x_1'] = newtableDatasv[index]['sdsA_1_x_1'];
                                item['sdsA_1_x_2'] = newtableDatasv[index]['sdsA_1_x_2'];
                            } else {
                                item['sdsA_1_x_2'] = newtableDatasv[index]['sdsA_1_x_1'];
                                if (newtableDatasv[index].hanh == 11) {
                                    item['sdsA_1_x_2'].cellVal = '0.25';
                                }
                            }
                        }
                    });
                    oldsv.forEach((ytem) => {
                        if (ytem.groud == newtableDatasv[index].hanh) {
                            item['groud'] = ytem['groud'];
                            item['title'] = ytem['title'];
                            item['disabledsdsA_1_x_1'] = ytem['disabledsdsA_1_x_1'];
                        }
                    });
                }
            });
            this.tableDatasv = realtableDatasv;
            this.changeqiylx(this.headobj);

            var newtableDatasvi = dataarr.sdsA_1.filter((item, index) => parseFloat(item.hanh) > 16 && parseFloat(item.hanh) < 23);
            var realtableDatasvi = getdataI().tableDatasvi;
            realtableDatasvi.forEach((item, index) => {
                if (newtableDatasvi[index]) {
                    this.IHead.forEach((gtem) => {
                        if (typeof newtableDatasvi[index][gtem] != 'undefined' && typeof newtableDatasvi[index][gtem] != undefined) {
                            if (newtableDatasvi[index].hanh == '17') {
                                item['sdsA_1_x_3'] = newtableDatasvi[index]['sdsA_1_x_1'];
                            }
                            if (newtableDatasvi[index].hanh == '18') {
                                item['sdsA_1_x_2'] = newtableDatasvi[index]['sdsA_1_x_1'];
                                item['sdsA_1_x_3'] = newtableDatasvi[index]['sdsA_1_x_2'];
                            }
                            if (newtableDatasvi[index].hanh == '19') {
                                item['sdsA_1_x_2'] = newtableDatasvi[index]['sdsA_1_x_1'];
                                item['sdsA_1_x_3'] = newtableDatasvi[index]['sdsA_1_x_2'];
                            }
                            if (newtableDatasvi[index].hanh == '20') {
                                item['sdsA_1_x_1'] = newtableDatasvi[index]['sdsA_1_x_1'];
                                item['sdsA_1_x_2'] = newtableDatasvi[index]['sdsA_1_x_2'];
                                item['sdsA_1_x_3'] = newtableDatasvi[index]['sdsA_1_x_3'];
                            }
                            if (newtableDatasvi[index].hanh == '21') {
                                item['sdsA_1_x_3'] = newtableDatasvi[index]['sdsA_1_x_1'];
                            }
                            if (newtableDatasvi[index].hanh == '22') {
                                item['sdsA_1_x_3'] = newtableDatasvi[index]['sdsA_1_x_1'];
                            }
                        }
                    });
                }
            });
            this.tableDatasvi = realtableDatasvi;
            this.tableDatasvi.map((item) => {
                if (item.sdsA_1_x_1 && item.sdsA_1_x_1.cellCode == 'sdsA_1_20_1') {
                    item.sdsA_1_x_1.cellVal = item.sdsA_1_x_1.cellVal == '' ? 0 : this.$numMulti(item.sdsA_1_x_1.cellVal, 100);
                }
                if (
                    item.sdsA_1_x_2 &&
                    (item.sdsA_1_x_2.cellCode == 'sdsA_1_20_2' ||
                        item.sdsA_1_x_2.cellCode == 'sdsA_1_18_1' ||
                        item.sdsA_1_x_2.cellCode == 'sdsA_1_19_1')
                ) {
                    item.sdsA_1_x_2.cellVal = item.sdsA_1_x_2.cellVal == '' ? 0 : this.$numMulti(item.sdsA_1_x_2.cellVal, 100);
                }
            });
            var newtableDatasvii = dataarr.sdsA_1.filter((item, index) => parseFloat(item.hanh) > 22);
            var realtableDatasvii = getdataI().tableDatasvii;
            var sdsA_1_x_1 = {};
            var sdsA_1_x_2 = {};
            var sdsA_1_x_3 = {};
            realtableDatasvii.forEach((item, index) => {
                if (newtableDatasvii[index]) {
                    this.IHead.forEach((gtem) => {
                        if (typeof newtableDatasvii[index][gtem] != 'undefined' && typeof newtableDatasvii[index][gtem] != undefined) {
                            if (newtableDatasvii[index].hanh != '23') {
                                item['sdsA_1_x_3'] = newtableDatasvii[index]['sdsA_1_x_1'];
                            }
                        }
                    });
                    this.IHead.forEach((gtem) => {
                        if (typeof newtableDatasvii[index][gtem] != 'undefined' && typeof newtableDatasvii[index][gtem] != undefined) {
                            if (newtableDatasvii[index].hanh == '23') {
                                item['sdsA_1_x_1'] = newtableDatasvii[4].sdsA_1_x_1;
                                item['sdsA_1_x_2'] = newtableDatasvii[4].sdsA_1_x_2;
                                item['sdsA_1_x_3'] = newtableDatasvii[index].sdsA_1_x_1;
                            }
                        }
                    });
                    this.IHead.forEach((gtem) => {
                        if (typeof newtableDatasvii[index][gtem] != 'undefined' && typeof newtableDatasvii[index][gtem] != undefined) {
                            if (newtableDatasvii[index].hanh == '23.2') {
                                item['sdsA_1_x_3'] = newtableDatasvii[index]['sdsA_1_x_3'];
                            }
                        }
                    });
                    // this.IHead.forEach(gtem => {
                    // 		if(typeof newtableDatasvii[index][gtem] !='undefined'&&typeof newtableDatasvii[index][gtem] !=undefined){
                    // 			if(newtableDatasvii[index].hanh=="23.2"){
                    // 				item['sdsA_1_x_1'] = newtableDatasvii[index]['sdsA_1_x_1']
                    // 				item['sdsA_1_x_2'] = newtableDatasvii[index]['sdsA_1_x_2']
                    // 				item['sdsA_1_x_3'] = newtableDatasvii[index]['sdsA_1_x_3']
                    // 			}else{
                    // 				item['sdsA_1_x_3'] = newtableDatasvii[index]['sdsA_1_x_1']
                    // 			}
                    // 		}
                    // })
                }
            });
            this.tableDatasvii = realtableDatasvii;
            this.tableDatasvii.map((item) => {
                if (item.sdsA_1_x_2) {
                    item.sdsA_1_x_2.cellVal = item.sdsA_1_x_2.cellVal == '' ? 0 : this.$numMulti(item.sdsA_1_x_2.cellVal, 100);
                }
            });
            // //III
            var newtableDataIII = dataarr.sdsA_3.filter((item, index) => index == 0);
            var realtableDataIII = getdataIII().tableData;
            realtableDataIII.forEach((item, index) => {
                if (newtableDataI[index]) {
                    this.IIIHead.forEach((gtem) => {
                        item[gtem] = newtableDataIII[index][gtem];
                    });
                }
            });
            this.tableDataIII = realtableDataIII;
            var newtableDatavx = dataarr.sdsA_3.filter((item, index) => index > 0);
            var realtableDatavx = newtableDatavx;
            realtableDatavx.forEach((item, index) => {
                if (newtableDatavx[index]) {
                    this.IIIHead.forEach((gtem) => {
                        if (index == realtableDatavx.length - 1) {
                            item.sdsA_3_x_1 = {
                                cellCode: '',
                                cellVal: '合计'
                            };
                            item.sdsA_3_x_2 = {
                                cellCode: '',
                                cellVal: '合计'
                            };
                            item.sdsA_3_x_3 = newtableDatavx[index].sdsA_3_x_3;
                            item.sdsA_3_x_4 = newtableDatavx[index].sdsA_3_x_4;
                            item.sdsA_3_x_5 = newtableDatavx[index].sdsA_3_x_5;
                            item.sdsA_3_x_6 = newtableDatavx[index].sdsA_3_x_6;
                            item.sdsA_3_x_7 = newtableDatavx[index].sdsA_3_x_7;
                            item.sdsA_3_x_8 = newtableDatavx[index].sdsA_3_x_8;
                            item.sdsA_3_x_9 = newtableDatavx[index].sdsA_3_x_9;
                            item.sdsA_3_x_10 = newtableDatavx[index].sdsA_3_x_10;
                        } else {
                            item[gtem] = newtableDatavx[index][gtem];
                        }
                    });
                }
            });
            this.tableDatavx = realtableDatavx;
            // this.tableDatavx.map(item => {
            // 	if (item.sdsA_3_x_6) {
            // 		item.sdsA_3_x_6.cellVal = item.sdsA_3_x_6.cellVal == '' ? 0 : this.$numMulti(item.sdsA_3_x_6.cellVal, 100);
            // 	}
            // });

            // this.tableDataII = getdataII().tableData
            // //III
            // this.tableDataIII = getdataIII().tableData
            // this.tableDatavx = getdataIII().tableDatavx
            // //VI
            // this.tableDataVI = getdataVI().tableData
            // //V
            // this.tableDataV = getdataV().tableData

            // var newtabledataI = dataarr.zzs_1
            // var realtableDataI = getdataI().tableData
            // realtableDataI.forEach((item, index) => {
            // 	if (newtabledataI[index]) {
            // 		this.IHead.forEach(gtem => {
            // 			item[gtem] = newtabledataI[index][gtem]
            // 		})
            // 	}
            // })

            // //附表二
            // var newtabledataII = dataarr.zzs_2
            // var newtabledataII_I = newtabledataII.filter((item, index) => index < 13)
            // var realtableDataII_I = getdataII().tableDataI
            // realtableDataII_I.forEach((item, index) => {
            // 	if (newtabledataII_I[index]) {
            // 		this.IIHead.forEach(gtem => {
            // 			item[gtem] = newtabledataII_I[index][gtem]
            // 		})
            // 	}
            // })

            // this.tableDataII_I = realtableDataII_I
            // var newtabledataII_II = newtabledataII.filter((item, index) => index > 12 & index < 25)
            // var realtableDataII_II = getdataII().tableDataII
            // realtableDataII_II.forEach((item, index) => {
            // 	if (newtabledataII_II[index]) {
            // 		item.zzs_2_x_3 = newtabledataII_II[index].zzs_2_x_1
            // 	}
            // })
            // this.tableDataII_II = realtableDataII_II
            // var newtabledataII_III = newtabledataII.filter((item, index) => index > 24 & index < 36)
            // var realtableDataII_III = getdataII().tableDataIII
            // realtableDataII_III.forEach((item, index) => {
            // 	if (newtabledataII_III[index]) {
            // 		this.IIHead.forEach(gtem => {
            // 			item[gtem] = newtabledataII_III[index][gtem]
            // 		})
            // 	}
            // })
        },
        IdelCellsCode(e) {
            this.delCellsI = [...this.filternums(e, this.IHead)];
        },
        IIIdelCellsCode(e) {
            this.delCellsIII = [...this.filternums(e, this.IIIHead)];
        },
        checkerror() {
            let arr = [];
            if (this.gettableval('sdsA_1_12_1', 'tableDatasv') < 0) {
                arr.push('企业所得税主表第12栏 不满足>=0');
            }
            if (
                !(
                    this.gettableval('sdsA_1_3_1', 'tableDatasv') +
                        this.gettableval('sdsA_1_4_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_5_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_6_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_7_1', 'tableDatasv') >
                    0
                ) &&
                this.gettableval('sdsA_1_8_1', 'tableDatasv') != 0
            ) {
                arr.push('企业所得税主表第3栏+第4栏-第5栏-第6栏-第7栏 不满足<=0，则第8栏不填报');
            }
            if (this.headobj.xiaoxwlqy == '' || this.headobj.xiaoxwlqy == null || this.headobj.xiaoxwlqy == '0') {
                arr.push('请选择是否是小型微利企业');
            }
            if (this.headobj.guojxzhjzhy == '' || this.headobj.guojxzhjzhy == null || this.headobj.guojxzhjzhy == '0') {
                arr.push('请选择是否是国家限制或禁止行业');
            }
            if (arr.length > 0) {
                this.errarr = arr;
                this.errdiag = true;
                return false;
            } else {
                return true;
            }
        },

        forsave() {
            let status = this.checkerror();
            if (!status) {
                return;
            }
			            let Ispand=false
			            this.tableDatasv.map(v=>{
			                if(v.hanh=='7.1'||v.hanh=='7.2'||v.hanh=='7.3'||v.hanh=='8.1'||v.hanh=='8.2'||v.hanh=='13.1'||v.hanh=='13.2'){
								if(!Ispand){
									if(v.sdsA_1_x_2.cellVal!=""&&v.sdsA_1_x_2.cellVal!="0"&&v.sdsA_1_x_2.cellVal!="0.00"){
									   if(v.sdsA_1_x_1.cellVal==""||v.sdsA_1_x_1.cellVal=="0"){
									       this.$message.error("请选择减免项");
									       Ispand=true
									   }
									}
								}
			                }
			            })
			            if(Ispand){
			                return;
			            }
            const newarr = [
                ...this.filternums(this.tableDataI, this.IHead),
                ...this.filternums(this.tableDatas, this.IHead),
                ...this.filternums(this.tableDatasv, this.IHead),
                ...this.filternums(this.tableDatasvi, this.IHead),
                ...this.filternums(this.tableDatasvii, this.IHead),
                ...this.filternums(this.tableDataIII, this.IIIHead),
                ...this.filternums(this.tableDatavx, this.IIIHead),
                ...this.filternums(this.tableDataII, this.IIHead)
            ];
            newarr.map((item) => {
                if (
                    item.cellCode &&
                    ['sdsA_1_20_2', 'sdsA_1_18_1', 'sdsA_1_19_1', 'sdsA_1_20_1'].includes(item.cellCode) &&
                    item.cellVal != '- -'
                ) {
                    if(item.cellCode == 'sdsA_1_20_2'){
                        item.cellVal = this.toFixed(item.cellVal * (0.01),12)
                    }else{
                        item.cellVal = item.cellVal * (0.01).toFixed(2);
                    }
                    console.log(item.cellVal)
                }
                if (item.cellCode && ['sdsA_1_23.2_2'].includes(item.cellCode) && item.cellVal != '- -') {
                    item.cellVal = item.cellVal * (0.01).toFixed(2);
                }
            });
            let params = {
                cells: newarr,
                checkFlag: true,
                companyNo: this.params.companyNo,
                id: this.params.id,
                sbbm: this.params.sbbm,
                head: this.headobj,
                delCells: [...this.delCellsI, ...this.delCellsIII]
            };
            writesave(params).then((res) => {
                if (res.data.code == 1) {
                    this.Changed = 0;
                    this.querycell();
                    this.$message.success(res.data.msg);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        inputblur(e) {
            console.log(e)
            this.Changed++;
            let cellval = e.cellVal == '' ? '0.00' : e.cellVal;
			if (e.cellCode!="sdsA_1_13.1_1") {
                if (this[this.choosetable]) {
                    let curCellCode = this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'];
                    let curCellOldValue = this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal'];
                    if (
                        parseFloat(e.cellVal).toFixed(2) != parseFloat(curCellOldValue).toFixed(2) && curCellCode == e.cellCode
                    ) {
                        this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
                    }
                }
			}
           
            if (
                e.cellCode == 'sdsA_1_7.1_1' ||
                e.cellCode == 'sdsA_1_7.2_1' ||
                e.cellCode == 'sdsA_1_7.3_1' ||
                e.cellCode == 'sdsA_1_13.1_1' ||
                e.cellCode == 'sdsA_1_13.2_1' ||
                e.cellCode == 'sdsA_1_18_1' ||
                e.cellCode == 'sdsA_1_19_1' ||
                e.cellCode == 'sdsA_1_20_2' ||
                e.cellCode == 'sdsA_1_20_1' ||
                e.cellCode == 'sdsA_1_23.2_2' ||
                e.cellCode == 'sdsA_1_23.2_3'
            ) {
                if (e.cellVal != 0 && e.cellVal != '' && e.cellVal != null) {
                    e.cellType = '1';
                }
            }
            if (
                (e.cellCode.substring(0, 10) == 'sdsA_1_13.' && e.cellVal == '高新技术企业减按15%的税率征收企业所得税') ||
                e.cellVal == '符合条件的小型微利企业减免企业所得税' ||
                e.cellVal == '国家鼓励的软件企业减免企业所得税-全免' ||
                e.cellVal == '国家鼓励的软件企业减免企业所得税-免50%'
            ) {
				console.log(this.tableDatas)
				console.log(123123)
                if (
                    (e.cellVal == '国家鼓励的软件企业减免企业所得税-全免' || e.cellVal == '国家鼓励的软件企业减免企业所得税-免50%') &&
                    this.gettableval('sdsA_1_0d_1', 'tableDatas') == 'Y'
                ) {
                } else {
                    if (e.cellVal != '高新技术企业减按15%的税率征收企业所得税' && e.cellVal != '符合条件的小型微利企业减免企业所得税') {
                        this.$message.error('您未选择 ：软件集成电路企业按新政策或原政策执行优惠（单选：原政策/新政策） 该政策将不生效');
                    }else if(e.cellVal == '高新技术企业减按15%的税率征收企业所得税'&&this.gettableval('sdsA_1_0e_1', 'tableDatas') != 'Y'){
						  this.$message.error('您未选择 ：高新技术企业资格证书发证时间 该政策将不生效');
					}
                }
                this.getsdsA_1_13_1_2(e);
            }
			if (e.cellCode == 'sdsA_1_0d_1'||e.cellCode == 'sdsA_1_0e_1' ) {
			   this.getsdsA_1_13_1_2(e);
			}
            if (e.cellCode.substring(0, 9) == 'sdsA_1_7.') {
                this.getsdsA_1_7_1_2(e);
            }
            if (e.cellCode == 'sdsA_1_18_1' && e.cellVal < 0) {
                this.changetableval('sdsA_1_18_1', 'tableDatasvi', 0);
            }
            if (e.cellCode == 'sdsA_1_19_1' && e.cellVal < 0) {
                this.changetableval('sdsA_1_19_1', 'tableDatasvi', 0);
            }
            if (e.cellCode == 'sdsA_1_20_1' && e.cellVal < 0) {
                this.changetableval('sdsA_1_20_1', 'tableDatasvi', 0);
            }
            if (e.cellCode == 'sdsA_1_20_2' && e.cellVal < 0) {
                this.changetableval('sdsA_1_20_2', 'tableDatasvi', 0);
            }
            if (e.cellCode == 'sdsA_1_23.2_2' && e.cellVal < 0) {
                this.changetableval('sdsA_1_23.2_2', 'tableDatasvii', 0);
            }
            if (
                e.cellCode == 'sdsA_1_0a_1' ||
                e.cellCode == 'sdsA_1_0a_2' ||
                e.cellCode == 'sdsA_1_0a_3' ||
                e.cellCode == 'sdsA_1_0a_4' ||
                e.cellCode == 'sdsA_1_0a_5' ||
                e.cellCode == 'sdsA_1_0a_6' ||
                e.cellCode == 'sdsA_1_0a_7' ||
                e.cellCode == 'sdsA_1_0a_8'
            ) {
                let countsdsA_1_0a_1 = 0;
                if (this.gettableval('sdsA_1_0a_1', 'tableDataI') > 0 || this.gettableval('sdsA_1_0a_2', 'tableDataI') > 0) {
                    countsdsA_1_0a_1++;
                }
                if (this.gettableval('sdsA_1_0a_3', 'tableDataI') > 0 || this.gettableval('sdsA_1_0a_4', 'tableDataI') > 0) {
                    countsdsA_1_0a_1++;
                }
                if (this.gettableval('sdsA_1_0a_5', 'tableDataI') > 0 || this.gettableval('sdsA_1_0a_6', 'tableDataI') > 0) {
                    countsdsA_1_0a_1++;
                }
                if (this.gettableval('sdsA_1_0a_7', 'tableDataI') > 0 || this.gettableval('sdsA_1_0a_8', 'tableDataI') > 0) {
                    countsdsA_1_0a_1++;
                }
                countsdsA_1_0a_1 = countsdsA_1_0a_1 == 0 ? 1 : countsdsA_1_0a_1;
                this.changetableval(
                    'sdsA_1_0a_9',
                    'tableDataI',
                    Number(
                        (
                            ((this.gettableval('sdsA_1_0a_1', 'tableDataI') + this.gettableval('sdsA_1_0a_2', 'tableDataI')) / 2 +
                                (this.gettableval('sdsA_1_0a_3', 'tableDataI') + this.gettableval('sdsA_1_0a_4', 'tableDataI')) / 2 +
                                (this.gettableval('sdsA_1_0a_5', 'tableDataI') + this.gettableval('sdsA_1_0a_6', 'tableDataI')) / 2 +
                                (this.gettableval('sdsA_1_0a_7', 'tableDataI') + this.gettableval('sdsA_1_0a_8', 'tableDataI')) / 2) /
                            countsdsA_1_0a_1
                        ).toFixed(0)
                    )
                );
            }
            if (
                e.cellCode == 'sdsA_1_0b_1' ||
                e.cellCode == 'sdsA_1_0b_2' ||
                e.cellCode == 'sdsA_1_0b_3' ||
                e.cellCode == 'sdsA_1_0b_4' ||
                e.cellCode == 'sdsA_1_0b_5' ||
                e.cellCode == 'sdsA_1_0b_6' ||
                e.cellCode == 'sdsA_1_0b_7' ||
                e.cellCode == 'sdsA_1_0b_8'
            ) {
                let countsdsA_1_0b_1 = 0;
                if (this.gettableval('sdsA_1_0b_1', 'tableDataI') > 0 || this.gettableval('sdsA_1_0b_2', 'tableDataI') > 0) {
                    countsdsA_1_0b_1++;
                }
                if (this.gettableval('sdsA_1_0b_3', 'tableDataI') > 0 || this.gettableval('sdsA_1_0b_4', 'tableDataI') > 0) {
                    countsdsA_1_0b_1++;
                }
                if (this.gettableval('sdsA_1_0b_5', 'tableDataI') > 0 || this.gettableval('sdsA_1_0b_6', 'tableDataI') > 0) {
                    countsdsA_1_0b_1++;
                }
                if (this.gettableval('sdsA_1_0b_7', 'tableDataI') > 0 || this.gettableval('sdsA_1_0b_8', 'tableDataI') > 0) {
                    countsdsA_1_0b_1++;
                }
                countsdsA_1_0b_1 = countsdsA_1_0b_1 == 0 ? 1 : countsdsA_1_0b_1;
                this.changetableval(
                    'sdsA_1_0b_9',
                    'tableDataI',
                    ((this.gettableval('sdsA_1_0b_1', 'tableDataI') + this.gettableval('sdsA_1_0b_2', 'tableDataI')) / 2 +
                        (this.gettableval('sdsA_1_0b_3', 'tableDataI') + this.gettableval('sdsA_1_0b_4', 'tableDataI')) / 2 +
                        (this.gettableval('sdsA_1_0b_5', 'tableDataI') + this.gettableval('sdsA_1_0b_6', 'tableDataI')) / 2 +
                        (this.gettableval('sdsA_1_0b_7', 'tableDataI') + this.gettableval('sdsA_1_0b_8', 'tableDataI')) / 2) /
                        countsdsA_1_0b_1
                );
            }
            if (
                e.cellCode == 'sdsA_1_3_1' ||
                e.cellCode == 'sdsA_1_4_1' ||
                e.cellCode == 'sdsA_1_5_1' ||
                e.cellCode == 'sdsA_1_6_1' ||
                e.cellCode == 'sdsA_1_7_1' ||
                e.cellCode == 'sdsA_1_8_1'
            ) {
                if (
                    !(
                        this.gettableval('sdsA_1_3_1', 'tableDatasv') +
                            this.gettableval('sdsA_1_4_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_5_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_6_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_7_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_8_1', 'tableDatasv') >
                        0
                    )
                ) {
                    this.changetableval('sdsA_1_9_1', 'tableDatasv', 0);
                }
                if (this.headobj.yujfs == '1') {
                    this.changetableval(
                        'sdsA_1_10_1',
                        'tableDatasv',
                        this.gettableval('sdsA_1_3_1', 'tableDatasv') +
                            this.gettableval('sdsA_1_4_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_5_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_6_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_7_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_8_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_9_1', 'tableDatasv')
                    );
                }
            }
            if (e.cellCode == 'sdsA_1_9_1') {
                this.changetableval(
                    'sdsA_1_10_1',
                    'tableDatasv',
                    this.gettableval('sdsA_1_3_1', 'tableDatasv') +
                        this.gettableval('sdsA_1_4_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_5_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_6_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_7_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_8_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_9_1', 'tableDatasv')
                );
            }
            if (e.cellCode == 'sdsA_1_10_1') {
                if (this.gettableval('sdsA_1_10_1', 'tableDatasv') * this.gettableval('sdsA_1_11_1', 'tableDatasv') < 0) {
                    this.changetableval('sdsA_1_12_1', 'tableDatasv', 0);
                } else {
                    this.changetableval(
                        'sdsA_1_12_1',
                        'tableDatasv',
                        this.gettableval('sdsA_1_10_1', 'tableDatasv') * this.gettableval('sdsA_1_11_1', 'tableDatasv')
                    );
                }
                this.getsdsA_1_13_1_2(e);
                // if((this.gettableval("sdsA_1_10_1",'tableDatasv')*this.gettableval("sdsA_1_11_1",'tableDatasv'))<0){
                // 	this.$message.error("sdsA_1_12_1格子校验不正确")
                // }
                // this.tableDatasv.map(item=>{
                // 	if(item.sdsA_1_x_1.cellCode=="sdsA_1_13.1_1"){
                // 		if(item.sdsA_1_x_1.cellVal=='高新技术企业减按15%的税率征收企业所得税'){
                // 			this.changetableval("sdsA_1_13.1_2", 'tableDatasv',this.gettableval("sdsA_1_10_1",'tableDatasv')*0.1)
                // 		}
                // 	}
                // })
            }
            // if(e.cellCode == 'sdsA_1_13.1_1'){
            // 	this.tableDatasv.map(item=>{
            // 		if(item.sdsA_1_x_1.cellCode=="sdsA_1_13.1_1"){
            // 			if(item.sdsA_1_x_1.cellVal=='高新技术企业减按15%的税率征收企业所得税'){
            // 				this.changetableval("sdsA_1_13.1_2", 'tableDatasv',this.gettableval("sdsA_1_10_1",'tableDatasv')*0.1)
            // 			}
            // 		}
            // 	})
            // }
            if (e.cellCode == 'sdsA_1_11_1') {
                if (this.gettableval('sdsA_1_10_1', 'tableDatasv') * this.gettableval('sdsA_1_11_1', 'tableDatasv') < 0) {
                    this.changetableval('sdsA_1_12_1', 'tableDatasv', 0);
                } else {
                    this.changetableval(
                        'sdsA_1_12_1',
                        'tableDatasv',
                        this.gettableval('sdsA_1_10_1', 'tableDatasv') * this.gettableval('sdsA_1_11_1', 'tableDatasv')
                    );
                }
                // if((this.gettableval("sdsA_1_10_1",'tableDatasv')*this.gettableval("sdsA_1_11_1",'tableDatasv'))<0){
                // 	this.$message.error("sdsA_1_12_1格子校验不正确")
                // }
            }
            if (e.cellCode == 'sdsA_1_12_1') {
                this.getsdsA_1_13_1_2(e);
                this.changetableval(
                    'sdsA_1_23.2_3',
                    'tableDatasvii',
                    (this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_15_1', 'tableDatasv')) *
                        0.4 *
                        this.gettableval('sdsA_1_23.2_2', 'tableDatasvii')
                );
                if (
                    this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_14_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_15_1', 'tableDatasv') >
                    0
                ) {
                    this.changetableval(
                        'sdsA_1_16_1',
                        'tableDatasv',
                        this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_14_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_15_1', 'tableDatasv')
                    );
                } else {
                    this.changetableval('sdsA_1_16_1', 'tableDatasv', 0);
                }
            }
            if (e.cellCode == 'sdsA_1_13_1') {
                this.changetableval(
                    'sdsA_1_23.2_3',
                    'tableDatasvii',
                    (this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_15_1', 'tableDatasv')) *
                        0.4 *
                        this.gettableval('sdsA_1_23.2_2', 'tableDatasvii')
                );
                if (
                    this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_14_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_15_1', 'tableDatasv') >
                    0
                ) {
                    this.changetableval(
                        'sdsA_1_16_1',
                        'tableDatasv',
                        this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_14_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_15_1', 'tableDatasv')
                    );
                } else {
                    this.changetableval('sdsA_1_16_1', 'tableDatasv', 0);
                }
            }
            if (e.cellCode == 'sdsA_1_14_1') {
                if (
                    this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_14_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_15_1', 'tableDatasv') >
                    0
                ) {
                    this.changetableval(
                        'sdsA_1_16_1',
                        'tableDatasv',
                        this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_14_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_15_1', 'tableDatasv')
                    );
                } else {
                    this.changetableval('sdsA_1_16_1', 'tableDatasv', 0);
                }
            }
            if (e.cellCode.substring(0, 10) == 'sdsA_1_13.') {
                this.getsdsA_1_13_1();
            }
            if (e.cellCode == 'sdsA_1_15_1') {
                this.changetableval(
                    'sdsA_1_23.2_3',
                    'tableDatasvii',
                    (this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_15_1', 'tableDatasv')) *
                        0.4 *
                        this.gettableval('sdsA_1_23.2_2', 'tableDatasvii')
                );
                if (
                    this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_14_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_15_1', 'tableDatasv') >
                    0
                ) {
                    this.changetableval(
                        'sdsA_1_16_1',
                        'tableDatasv',
                        this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_14_1', 'tableDatasv') -
                            this.gettableval('sdsA_1_15_1', 'tableDatasv')
                    );
                } else {
                    this.changetableval('sdsA_1_16_1', 'tableDatasv', 0);
                }
            }
            if (e.cellCode == 'sdsA_1_16_1') {
                this.changetableval(
                    'sdsA_1_18_2',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_16_1', 'tableDatasv') * this.gettableval('sdsA_1_18_1', 'tableDatasvi')
                );
                this.changetableval(
                    'sdsA_1_19_2',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_16_1', 'tableDatasv') * this.gettableval('sdsA_1_19_1', 'tableDatasvi')
                );
                this.changetableval(
                    'sdsA_1_20_3',
                    'tableDatasvi',
                    this.toFixed(this.gettableval('sdsA_1_16_1', 'tableDatasv') * this.gettableval('sdsA_1_20_1', 'tableDatasvi'), 2) *
                        this.gettableval('sdsA_1_20_2', 'tableDatasvi')
                );
                this.changetableval('sdsA_3_0a_1', 'tableDataIII', this.gettableval('sdsA_1_16_1', 'tableDatasv'));
                this.changetableval(
                    'sdsA_3_0a_4',
                    'tableDataIII',
                    this.gettableval('sdsA_3_0a_1', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_2', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_3', 'tableDataIII')
                );
                this.changesdsA_1_22_1_1();
                this.changesdsA_1_22_2_1();
            }
            if (e.cellCode == 'sdsA_1_18_1') {
                this.changetableval(
                    'sdsA_1_18_2',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_16_1', 'tableDatasv') * this.gettableval('sdsA_1_18_1', 'tableDatasvi')
                );
                this.changetableval(
                    'sdsA_3_0a_4',
                    'tableDataIII',
                    this.gettableval('sdsA_1_16_1', 'tableDataIII') * (1 - this.gettableval('sdsA_1_18_1', 'tableDataIII'))
                );
            }
            if (e.cellCode == 'sdsA_1_18_2') {
                this.changetableval(
                    'sdsA_1_17_1',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_18_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_19_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_20_3', 'tableDatasvi')
                );
                this.changetableval('sdsA_3_0a_2', 'tableDataIII', this.gettableval('sdsA_1_18_2', 'tableDatasvi'));
                this.changetableval(
                    'sdsA_3_0a_4',
                    'tableDataIII',
                    this.gettableval('sdsA_3_0a_1', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_2', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_3', 'tableDataIII')
                );
                this.changesdsA_1_22_1_1();
                this.changesdsA_1_22_2_1();
            }
            if (e.cellCode == 'sdsA_1_19_1') {
                this.changetableval(
                    'sdsA_1_19_2',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_16_1', 'tableDatasv') * this.gettableval('sdsA_1_19_1', 'tableDatasvi')
                );
            }
            if (e.cellCode == 'sdsA_1_19_2') {
                this.changetableval(
                    'sdsA_1_17_1',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_18_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_19_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_20_3', 'tableDatasvi')
                );
                this.changetableval('sdsA_3_0a_3', 'tableDataIII', this.gettableval('sdsA_1_19_2', 'tableDatasvi'));
                this.changetableval(
                    'sdsA_3_0a_4',
                    'tableDataIII',
                    this.gettableval('sdsA_3_0a_1', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_2', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_3', 'tableDataIII')
                );
                this.changesdsA_1_22_1_1();
            }
            if (e.cellCode == 'sdsA_1_20_1') {
                this.changetableval(
                    'sdsA_1_20_3',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_16_1', 'tableDatasv') *
                        this.gettableval('sdsA_1_20_1', 'tableDatasvi') *
                        this.gettableval('sdsA_1_20_2', 'tableDatasvi')
                );
                this.changetableval(
                    'sdsA_1_17_1',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_18_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_19_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_20_3', 'tableDatasvi')
                );
            }
            if (e.cellCode == 'sdsA_1_20_2') {
                console.log( this.gettableval('sdsA_1_20_2', 'tableDatasvi'))
                this.changetableval(
                    'sdsA_1_20_3',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_16_1', 'tableDatasv') *
                        this.gettableval('sdsA_1_20_1', 'tableDatasvi') *
                        this.gettableval('sdsA_1_20_2', 'tableDatasvi')
                );
                this.changetableval(
                    'sdsA_1_17_1',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_18_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_19_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_20_3', 'tableDatasvi')
                );
            }
            if (e.cellCode == 'sdsA_1_20_3') {
                this.changetableval(
                    'sdsA_1_17_1',
                    'tableDatasvi',
                    this.gettableval('sdsA_1_18_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_19_2', 'tableDatasvi') +
                        this.gettableval('sdsA_1_20_3', 'tableDatasvi')
                );
                this.changesdsA_1_22_1_1();
                this.changesdsA_1_22_2_1();
            }
            if (e.cellCode == 'sdsA_1_22_1') {
                this.changesdsA_1_22_1_1();
                this.changesdsA_1_22_2_1();
            }
            if (e.cellCode == 'sdsA_1_22.1_1') {
                this.changetableval(
                    'sdsA_1_24_1',
                    'tableDatasvii',
                    this.gettableval('sdsA_1_22.1_1', 'tableDatasvii') + this.gettableval('sdsA_1_23.3_1', 'tableDatasvii')
                );
            }
            if (e.cellCode == 'sdsA_1_22.2_1') {
                this.changetableval(
                    'sdsA_1_23_1',
                    'tableDatasvii',
                    this.gettableval('sdsA_1_22.2_1', 'tableDatasvii') * this.gettableval('sdsA_1_23.2_2', 'tableDatasvii')
                );
                this.changetableval(
                    'sdsA_1_23.3_1',
                    'tableDatasvii',
                    this.gettableval('sdsA_1_22.2_1', 'tableDatasvii') - this.gettableval('sdsA_1_23.1_1', 'tableDatasvii')
                );
            }
            if (e.cellCode == 'sdsA_1_23_1') {
                this.changetableval('sdsA_1_23.1_1', 'tableDatasvii', this.gettableval('sdsA_1_23_1', 'tableDatasvii'));
            }
            if (e.cellCode == 'sdsA_1_23.1_1') {
                this.changetableval(
                    'sdsA_1_23.3_1',
                    'tableDatasvii',
                    this.gettableval('sdsA_1_22.2_1', 'tableDatasvii') - this.gettableval('sdsA_1_23.1_1', 'tableDatasvii')
                );
            }
            if (e.cellCode == 'sdsA_1_23.2_2') {
                this.changetableval(
                    'sdsA_1_23.2_3',
                    'tableDatasvii',
                    (this.gettableval('sdsA_1_12_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_13_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_15_1', 'tableDatasv')) *
                        0.4 *
                        this.gettableval('sdsA_1_23.2_2', 'tableDatasvii')
                );
                this.changetableval(
                    'sdsA_1_23_1',
                    'tableDatasvii',
                    this.gettableval('sdsA_1_22.2_1', 'tableDatasvii') * this.gettableval('sdsA_1_23.2_2', 'tableDatasvii')
                );
            }
            if (e.cellCode == 'sdsA_1_23.3_1') {
                this.changetableval(
                    'sdsA_1_24_1',
                    'tableDatasvii',
                    this.gettableval('sdsA_1_22.1_1', 'tableDatasvii') + this.gettableval('sdsA_1_23.3_1', 'tableDatasvii')
                );
            }
            if (e.cellCode == 'sdsA_3_0a_1') {
                this.changetableval(
                    'sdsA_3_0a_4',
                    'tableDataIII',
                    this.gettableval('sdsA_3_0a_1', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_2', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_3', 'tableDataIII')
                );
            }
            if (e.cellCode == 'sdsA_3_0a_2') {
                this.changetableval(
                    'sdsA_3_0a_4',
                    'tableDataIII',
                    this.gettableval('sdsA_3_0a_1', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_2', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_3', 'tableDataIII')
                );
            }
            if (e.cellCode == 'sdsA_3_0a_3') {
                this.changetableval(
                    'sdsA_3_0a_4',
                    'tableDataIII',
                    this.gettableval('sdsA_3_0a_1', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_2', 'tableDataIII') -
                        this.gettableval('sdsA_3_0a_3', 'tableDataIII')
                );
            }
            // if (e.cellCode == 'sdsA_3_0a_4') {
            // 	this.changetableval('sdsA_3_1_10', 'tableDatasvi', this.gettableval('sdsA_3_1_6', 'tableDatavx')*
            // 		this.gettableval('sdsA_3_0a_4', 'tableDatavx') -this.gettableval('sdsA_3_1_8', 'tableDatavx') -
            // 		this.gettableval('sdsA_3_1_9', 'tableDatavx'))
            // }
            // if (e.cellCode == 'sdsA_3_1_3') {
            // this.changetableval(
            // 	'sdsA_3_1_6',
            // 	'tableDatavx',
            // 	((this.gettableval('sdsA_3_1_3', 'tableDatavx') / this.gettableval('sdsA_3_1000_3', 'tableDatavx')) * 0.35 +
            // 		(this.gettableval('sdsA_3_1_4', 'tableDatavx') / this.gettableval('sdsA_3_1000_4', 'tableDatavx')) * 0.35 +
            // 		(this.gettableval('sdsA_3_1_5', 'tableDatavx') / this.gettableval('sdsA_3_1000_5', 'tableDatavx')) * 0.3) /
            // 		this.gettableval('sdsA_3_0a_4', 'tableDataIII')
            // );

            // this.changetableval("sdsA_3_1_10", 'tableDatavx',(this.gettableval("sdsA_3_1_3",'tableDatavx')/this.gettableval("sdsA_3_1000_3",'tableDatavx')*0.35)+
            // (this.gettableval("sdsA_3_1_4",'tableDatavx')/this.gettableval("sdsA_3_1000_4",'tableDatavx')*0.35)+
            // (this.gettableval("sdsA_3_1_5",'tableDatavx')/this.gettableval("sdsA_3_1000_5",'tableDatavx')*0.3)-this.gettableval("sdsA_3_1_8",'tableDatavx')*0.01-this.gettableval("sdsA_3_1_9",'tableDatavx'))
            // }
            // if (e.cellCode == 'sdsA_3_1_4') {
            // this.changetableval("sdsA_3_1_6", 'tableDatavx',((this.gettableval("sdsA_3_1_3",'tableDatavx')/this.gettableval("sdsA_3_1000_3",'tableDatavx')*0.35)+
            // (this.gettableval("sdsA_3_1_4",'tableDatavx')/this.gettableval("sdsA_3_1000_4",'tableDatavx')*0.35)+
            // (this.gettableval("sdsA_3_1_5",'tableDatavx')/this.gettableval("sdsA_3_1000_5",'tableDatavx')*0.3))/this.gettableval("sdsA_3_0a_4",'tableDataIII'))
            // this.changetableval("sdsA_3_1_10", 'tableDatavx',(this.gettableval("sdsA_3_1_3",'tableDatavx')/this.gettableval("sdsA_3_1000_3",'tableDatavx')*0.35)+
            // (this.gettableval("sdsA_3_1_4",'tableDatavx')/this.gettableval("sdsA_3_1000_4",'tableDatavx')*0.35)+
            // (this.gettableval("sdsA_3_1_5",'tableDatavx')/this.gettableval("sdsA_3_1000_5",'tableDatavx')*0.3)-this.gettableval("sdsA_3_1_8",'tableDatavx')*0.01-this.gettableval("sdsA_3_1_9",'tableDatavx'))
            // }
            // if (e.cellCode == 'sdsA_3_1_6') {
            // 	this.changetableval('sdsA_1_21_1', 'tableDatasvi', this.gettableval('sdsA_3_1_6', 'tableDatavx'));
            // 	this.changetableval('sdsA_3_1_10', 'tableDatasvi', this.gettableval('sdsA_3_1_6', 'tableDatavx')*
            // 		this.gettableval('sdsA_3_0a_4', 'tableDatavx') -this.gettableval('sdsA_3_1_8', 'tableDatavx') -
            // 		this.gettableval('sdsA_3_1_9', 'tableDatavx')) ;
            // }
            // if (e.cellCode == 'sdsA_3_1_8') {
            // 	this.changetableval('sdsA_1_21_1', 'tableDatasvi', this.gettableval('sdsA_3_1_6', 'tableDatavx'));
            // 	this.changetableval('sdsA_3_1_10', 'tableDatasvi', this.gettableval('sdsA_3_1_6', 'tableDatavx')*
            // 		this.gettableval('sdsA_3_0a_4', 'tableDatavx') -this.gettableval('sdsA_3_1_8', 'tableDatavx') -
            // 		this.gettableval('sdsA_3_1_9', 'tableDatavx')) ;
            // }
            // if (e.cellCode == 'sdsA_3_1_9') {
            // 	this.changetableval('sdsA_1_21_1', 'tableDatasvi', this.gettableval('sdsA_3_1_6', 'tableDatavx'));
            // 	this.changetableval('sdsA_3_1_10', 'tableDatasvi', this.gettableval('sdsA_3_1_6', 'tableDatavx')*
            // 		this.gettableval('sdsA_3_0a_4', 'tableDatavx') -this.gettableval('sdsA_3_1_8', 'tableDatavx') -
            // 		this.gettableval('sdsA_3_1_9', 'tableDatavx'))
            // }

            // if (e.cellCode == 'sdsA_3_1_10') {
            // this.changetableval('sdsA_1_22_1', 'tableDatasvi', this.gettableval('sdsA_3_1_10', 'tableDatavx'));
            // }
            // if(e.cellCode=="sdsA_3_1000_3"){
            // 	// this.changetableval("sdsA_3_1_6", 'tableDatavx',((this.gettableval("sdsA_3_1_3",'tableDatavx')/this.gettableval("sdsA_3_1000_3",'tableDatavx')*0.35)+
            // 	// (this.gettableval("sdsA_3_1_4",'tableDatavx')/this.gettableval("sdsA_3_1000_4",'tableDatavx')*0.35)+
            // 	// (this.gettableval("sdsA_3_1_5",'tableDatavx')/this.gettableval("sdsA_3_1000_5",'tableDatavx')*0.3))/this.gettableval("sdsA_3_0a_4",'tableDataIII'))

            // 	this.changetableval("sdsA_3_1_10", 'tableDatavx',(this.gettableval("sdsA_3_1_3",'tableDatavx')/this.gettableval("sdsA_3_1000_3",'tableDatavx')*0.35)+
            // 	(this.gettableval("sdsA_3_1_4",'tableDatavx')/this.gettableval("sdsA_3_1000_4",'tableDatavx')*0.35)+
            // 	(this.gettableval("sdsA_3_1_5",'tableDatavx')/this.gettableval("sdsA_3_1000_5",'tableDatavx')*0.3)-this.gettableval("sdsA_3_1_8",'tableDatavx')*0.01-this.gettableval("sdsA_3_1_9",'tableDatavx'))
            // }
            // if(e.cellCode=="sdsA_3_1000_4"){
            // 	// this.changetableval("sdsA_3_1_6", 'tableDatavx',((this.gettableval("sdsA_3_1_3",'tableDatavx')/this.gettableval("sdsA_3_1000_3",'tableDatavx')*0.35)+
            // 	// (this.gettableval("sdsA_3_1_4",'tableDatavx')/this.gettableval("sdsA_3_1000_4",'tableDatavx')*0.35)+
            // 	// (this.gettableval("sdsA_3_1_5",'tableDatavx')/this.gettableval("sdsA_3_1000_5",'tableDatavx')*0.3))/this.gettableval("sdsA_3_0a_4",'tableDataIII'))

            // 	this.changetableval("sdsA_3_1_10", 'tableDatavx',(this.gettableval("sdsA_3_1_3",'tableDatavx')/this.gettableval("sdsA_3_1000_3",'tableDatavx')*0.35)+
            // 	(this.gettableval("sdsA_3_1_4",'tableDatavx')/this.gettableval("sdsA_3_1000_4",'tableDatavx')*0.35)+
            // 	(this.gettableval("sdsA_3_1_5",'tableDatavx')/this.gettableval("sdsA_3_1000_5",'tableDatavx')*0.3)-this.gettableval("sdsA_3_1_8",'tableDatavx')*0.01-this.gettableval("sdsA_3_1_9",'tableDatavx'))
            // }
            // if(e.cellCode=="sdsA_3_1000_5"){
            // 	// this.changetableval("sdsA_3_1_6", 'tableDatavx',((this.gettableval("sdsA_3_1_3",'tableDatavx')/this.gettableval("sdsA_3_1000_3",'tableDatavx')*0.35)+
            // 	// (this.gettableval("sdsA_3_1_4",'tableDatavx')/this.gettableval("sdsA_3_1000_4",'tableDatavx')*0.35)+
            // 	// (this.gettableval("sdsA_3_1_5",'tableDatavx')/this.gettableval("sdsA_3_1000_5",'tableDatavx')*0.3))/this.gettableval("sdsA_3_0a_4",'tableDataIII'))

            // 	this.changetableval("sdsA_3_1_10", 'tableDatavx',(this.gettableval("sdsA_3_1_3",'tableDatavx')/this.gettableval("sdsA_3_1000_3",'tableDatavx')*0.35)+
            // 	(this.gettableval("sdsA_3_1_4",'tableDatavx')/this.gettableval("sdsA_3_1000_4",'tableDatavx')*0.35)+
            // 	(this.gettableval("sdsA_3_1_5",'tableDatavx')/this.gettableval("sdsA_3_1000_5",'tableDatavx')*0.3)-this.gettableval("sdsA_3_1_8",'tableDatavx')*0.01-this.gettableval("sdsA_3_1_9",'tableDatavx'))
            // }
            this.getsdsA_3_x_10();
            // this.getsdsA_3_x_6();
            if (e.cellCode.substring(0, 6) == 'sdsA_3' && e.cellCode.substring(9, 10) == '3') {
                this.getsdsA_3_1000_3();
            }
            if (e.cellCode.substring(0, 6) == 'sdsA_3' && e.cellCode.substring(9, 10) == '4') {
                this.getsdsA_3_1000_4();
            }
            if (e.cellCode.substring(0, 6) == 'sdsA_3' && e.cellCode.substring(9, 10) == '5') {
                this.getsdsA_3_1000_5();
            }
            if (e.cellCode.substring(0, 6) == 'sdsA_3' && e.cellCode.substring(9, 10) == '6') {
                this.getsdsA_3_1000_6();
            }
            if (e.cellCode.substring(0, 6) == 'sdsA_3' && e.cellCode.substring(9, 10) == '9') {
                this.getsdsA_3_1000_9();
            }
            if (e.cellCode.substring(0, 6) == 'sdsA_3' && e.cellCode.substring(9, 11) == '10') {
                this.getsdsA_3_1000_10();
            }
            //附表二
            if (e.cellCode == 'sdsA_2_1.1_1') {
                this.changetableval(
                    'sdsA_2_1_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_1') {
                this.changetableval(
                    'sdsA_2_1_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_1') {
                this.changetableval(
                    'sdsA_2_1_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_1') {
                this.changetableval(
                    'sdsA_2_1_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.1_2') {
                this.changetableval(
                    'sdsA_2_1_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_2') {
                this.changetableval(
                    'sdsA_2_1_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_2') {
                this.changetableval(
                    'sdsA_2_1_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_2') {
                this.changetableval(
                    'sdsA_2_1_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.1_3') {
                this.changetableval(
                    'sdsA_2_1_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') - this.gettableval('sdsA_2_1.1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_3') {
                this.changetableval(
                    'sdsA_2_1_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.2_4', 'tableDataII') - this.gettableval('sdsA_2_1.2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_3') {
                this.changetableval(
                    'sdsA_2_1_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.3_4', 'tableDataII') - this.gettableval('sdsA_2_1.3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_3') {
                this.changetableval(
                    'sdsA_2_1_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.4_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.4_4', 'tableDataII') - this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.1_4') {
                this.changetableval(
                    'sdsA_2_1_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') - this.gettableval('sdsA_2_1.1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_4') {
                this.changetableval(
                    'sdsA_2_1_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.2_4', 'tableDataII') - this.gettableval('sdsA_2_1.2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_4') {
                this.changetableval(
                    'sdsA_2_1_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.3_4', 'tableDataII') - this.gettableval('sdsA_2_1.3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_4') {
                this.changetableval(
                    'sdsA_2_1_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.4_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.4_4', 'tableDataII') - this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.1_5') {
                this.changetableval(
                    'sdsA_2_1_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_5') {
                this.changetableval(
                    'sdsA_2_1_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_5') {
                this.changetableval(
                    'sdsA_2_1_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_5') {
                this.changetableval(
                    'sdsA_2_1_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_6') {
                this.changetableval(
                    'sdsA_2_1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_6', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_6') {
                this.changetableval(
                    'sdsA_2_1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_6', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_4') {
                this.changetableval(
                    'sdsA_2_1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_4', 'tableDataII') - this.gettableval('sdsA_2_1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_3') {
                this.changetableval(
                    'sdsA_2_1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_4', 'tableDataII') - this.gettableval('sdsA_2_1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') - this.gettableval('sdsA_2_2.1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.2_4', 'tableDataII') - this.gettableval('sdsA_2_2.2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.3_4', 'tableDataII') - this.gettableval('sdsA_2_2.3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.4_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.4_4', 'tableDataII') - this.gettableval('sdsA_2_2.4_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.5_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.5_4', 'tableDataII') - this.gettableval('sdsA_2_2.5_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.6_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.6_4', 'tableDataII') - this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') - this.gettableval('sdsA_2_2.1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.2_4', 'tableDataII') - this.gettableval('sdsA_2_2.2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.3_4', 'tableDataII') - this.gettableval('sdsA_2_2.3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.4_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.4_4', 'tableDataII') - this.gettableval('sdsA_2_2.4_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.5_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.5_4', 'tableDataII') - this.gettableval('sdsA_2_2.5_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.6_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.6_4', 'tableDataII') - this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_6') {
                this.changetableval(
                    'sdsA_2_2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2_4', 'tableDataII') + this.gettableval('sdsA_2_2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_1') {
                this.changetableval(
                    'sdsA_2_3_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_1', 'tableDataII') + this.gettableval('sdsA_2_2_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_1') {
                this.changetableval(
                    'sdsA_2_3_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_1', 'tableDataII') + this.gettableval('sdsA_2_2_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_2') {
                this.changetableval(
                    'sdsA_2_3_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_2', 'tableDataII') + this.gettableval('sdsA_2_2_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_2') {
                this.changetableval(
                    'sdsA_2_3_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_2', 'tableDataII') + this.gettableval('sdsA_2_2_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_3') {
                this.changetableval(
                    'sdsA_2_3_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_3', 'tableDataII') + this.gettableval('sdsA_2_2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_3') {
                this.changetableval(
                    'sdsA_2_3_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_3', 'tableDataII') + this.gettableval('sdsA_2_2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_4') {
                this.changetableval(
                    'sdsA_2_3_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_4', 'tableDataII') + this.gettableval('sdsA_2_2_4', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_4') {
                this.changetableval(
                    'sdsA_2_3_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_4', 'tableDataII') + this.gettableval('sdsA_2_2_4', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_5') {
                this.changetableval(
                    'sdsA_2_3_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_5', 'tableDataII') + this.gettableval('sdsA_2_2_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_5') {
                this.changetableval(
                    'sdsA_2_3_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_5', 'tableDataII') + this.gettableval('sdsA_2_2_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_3_3') {
                this.changetableval(
                    'sdsA_2_3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_3_4', 'tableDataII') + this.gettableval('sdsA_2_3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_3_4') {
                this.changetableval(
                    'sdsA_2_3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_3_4', 'tableDataII') + this.gettableval('sdsA_2_3_3', 'tableDataII')
                );
            }
        },
        changeqiylx(e) {
            this.changesdsA_1_22_1_1();
            this.changesdsA_1_22_2_1();
            if (e.qiylx == 2) {
                this.tableDatasv.map((item) => {
                    if (
                        item.sdsA_1_x_1.cellCode == 'sdsA_1_1_1' ||
                        item.sdsA_1_x_1.cellCode == 'sdsA_1_2_1' ||
                        item.sdsA_1_x_1.cellCode == 'sdsA_1_3_1'
                    ) {
                        item.sdsA_1_x_1.cellVal = '0.00';
                    }
                    if (
                        item.sdsA_1_x_2.cellCode == 'sdsA_1_1_1' ||
                        item.sdsA_1_x_2.cellCode == 'sdsA_1_2_1' ||
                        item.sdsA_1_x_2.cellCode == 'sdsA_1_3_1'
                    ) {
                        item.sdsA_1_x_2.cellVal = '0.00';
                    }
                });
                // this.changetableval('sdsA_1_1_1', 'tableDatasv',0)
                //   this.changetableval('sdsA_1_2_1', 'tableDatasv',0)
                //   this.changetableval('sdsA_1_3_1', 'tableDatasv',0)
            }
        },
        changesdsA_1_22_1_1() {
            if (this.headobj.qiylx == 0) {
                this.changetableval('sdsA_1_22.1_1', 'tableDatasvii', this.gettableval('sdsA_1_16_1', 'tableDatasv') * 0.6);
            }
            if (this.headobj.qiylx == 1) {
                this.changetableval(
                    'sdsA_1_22.1_1',
                    'tableDatasvii',
                    (this.gettableval('sdsA_1_18_2', 'tableDatasvi') + this.gettableval('sdsA_1_20_3', 'tableDatasvi')) * 0.6 +
                        this.gettableval('sdsA_1_19_2', 'tableDatasvi')
                );
            }
            if (this.headobj.qiylx == 2) {
                this.changetableval('sdsA_1_22.1_1', 'tableDatasvi', this.gettableval('sdsA_1_22_1', 'tableDatasvi') * 0.6);
            }
        },

        changesdsA_1_22_2_1() {
            if (this.headobj.qiylx == 0) {
                this.changetableval('sdsA_1_22.2_1', 'tableDatasvii', this.gettableval('sdsA_1_16_1', 'tableDatasv') * 0.4);
            }
            if (this.headobj.qiylx == 1) {
                this.changetableval(
                    'sdsA_1_22.2_1',
                    'tableDatasvii',
                    (this.gettableval('sdsA_1_18_2', 'tableDatasvi') + this.gettableval('sdsA_1_20_3', 'tableDatasvi')) * 0.4
                );
            }
            if (this.headobj.qiylx == 2) {
                this.changetableval('sdsA_1_22.2_1', 'tableDatasvi', this.gettableval('sdsA_1_22_1', 'tableDatasvi') * 0.4);
            }
        },
        yjfschange(e) {
            if (e == '1') {
                this.changetableval(
                    'sdsA_1_10_1',
                    'tableDatasv',
                    this.gettableval('sdsA_1_3_1', 'tableDatasv') +
                        this.gettableval('sdsA_1_4_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_5_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_6_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_7_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_8_1', 'tableDatasv') -
                        this.gettableval('sdsA_1_9_1', 'tableDatasv')
                );
            }
        },

        getsdsA_3_x_10() {
            let all = this.filternums(this.tableDatavx, this.IIIHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 6) == 'sdsA_3' && item.cellCode.substring(9, 11) == '10') {
                    this.changetableval(
                        'sdsA_3_' + item.cellCode.substring(7, 8) + '_10',
                        'tableDatavx',
                        this.gettableval('sdsA_3_' + item.cellCode.substring(7, 8) + '_6', 'tableDatavx') *
                            this.gettableval('sdsA_3_0a_4', 'tableDataIII') -
                            this.gettableval('sdsA_3_' + item.cellCode.substring(7, 8) + '_8', 'tableDatavx') -
                            this.gettableval('sdsA_3_' + item.cellCode.substring(7, 8) + '_9', 'tableDatavx')
                    );
                }
            });
        },
        getsdsA_3_x_6() {
            let all = this.filternums(this.tableDatavx, this.IIIHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 6) == 'sdsA_3' && item.cellCode.substring(9, 11) == '6') {
                    this.changetableval(
                        'sdsA_3_' + item.cellCode.substring(7, 8) + '_6',
                        'tableDatavx',
                        this.toFixed(this.gettableval('sdsA_3_' + item.cellCode.substring(7, 8) + '_6', 'tableDatavx'), 10),
                        null,
                        10
                    );
                }
            });
        },
        getsdsA_1_7_1_2(e) {
            let value = '';
            let towvalue = '';
            let total = 0;
            let all = this.filternums(this.tableDatasv, this.IHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 9) == 'sdsA_1_7.') {
                    if (item.cellCode.substring(11, 12) == '1') {
                        if (item.cellCode.substring(9, 10) == '1') {
                            value = item.cellVal;
                        } else {
                            towvalue = item.cellVal;
                        }
                    }
                }
            });
            all.forEach(item => {
                if (item.cellCode.substring(0, 9) == 'sdsA_1_7.') {
                    if (item.cellCode.substring(9, 10) == '1') {
                        if (value != '' && value != null && value != '0') {
                            total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                        }
                    } else {
                        if (towvalue != '' && towvalue != null && towvalue != '0') {
                            total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                        }
                    }
                }
            });
            this.changetableval('sdsA_1_7_1', 'tableDatasv', total);
        },
        getsdsA_1_13_1_2(e) {
            let Code = '';
            let len = '';
            let code = '';
            let value = '';
            let all = this.filternums(this.tableDatasv, this.IHead);
            all.map(item => {
                if (item.cellCode.substring(7, 11) == '13.2') {
                        Code = item.cellCode.substring(10, item.cellCode.length - 1);
                        len = 10 + Code.split('_').length - 1;
                        code = item.cellCode.substring(0, len) + '_2';
                        let code1 = item.cellCode.substring(0, len) + '_1';
                        if (item.cellCode == code1) {
                                value = item.cellVal;
                        }
                }
                let inso = 0 
                all.map(item=>{
                    if(item.cellCode == "sdsA_1_13.2_2"){
                        if(value!=null&&value!='0'){
                            item.cellType = '1'
                            inso++
                        }else if(inso!=0&&index == all.length-1){
                            item.cellType = '0'
                        }
                    }
                })
                if (value == '符合条件的小型微利企业减免企业所得税') {
                        if (this.gettableval('sdsA_1_10_1', 'tableDatasv') > 0) {
                                this.changetableval(code, 'tableDatasv', this.gettableval('sdsA_1_10_1', 'tableDatasv') * 0.25 * 0.8);
                        } else {
                                this.changetableval(code, 'tableDatasv', 0);
                        }
                }
                if (item.cellCode.substring(7, 11) == '13.1') {
                    Code = item.cellCode.substring(10, item.cellCode.length - 1);
                    len = 10 + Code.split('_').length - 1;
                    code = item.cellCode.substring(0, len) + '_2';
                    let code1 = item.cellCode.substring(0, len) + '_1';
                    if (item.cellCode == code1) {
                        value = item.cellVal;
                    }
                }
                let ins = 0 
                all.map((item,index)=>{
                    if(item.cellCode == "sdsA_1_13.1_2"){
                        if(value!=null&&value!='0'){
                            item.cellType = '1'
                            ins++
                        }else if(ins!=0&&index == all.length-1){
                            item.cellType = '0'
                        }
                    }
                })
            console.log(11)
                if (value == '高新技术企业减按15%的税率征收企业所得税'&&this.gettableval('sdsA_1_0e_1', 'tableDatas') == 'Y') {
                    if (this.gettableval('sdsA_1_10_1', 'tableDatasv') < 0) {
                        this.changetableval(code, 'tableDatasv', 0);
                    } else {
                        this.changetableval(code, 'tableDatasv', this.gettableval('sdsA_1_10_1', 'tableDatasv') * 0.1);
                    }
                }
                if (value == '国家鼓励的软件企业减免企业所得税-全免'&&this.gettableval('sdsA_1_0d_1', 'tableDatas')=='Y') {
                        this.changetableval(code, 'tableDatasv', this.gettableval('sdsA_1_12_1','tableDatasv'))
                }
                if (value == '国家鼓励的软件企业减免企业所得税-免50%'&&this.gettableval('sdsA_1_0d_1', 'tableDatas')=='Y') {
                        this.changetableval(code, 'tableDatasv', this.gettableval('sdsA_1_12_1','tableDatasv')*0.5)
                }
            });
        },
        
        getsdsA_1_13_1(changeval) {
            let total = 0;
            let all = this.filternums(this.tableDatasv, this.IHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 10) == 'sdsA_1_13.') {
                    total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                }
            });
            if (total < 0) {
                this.changetableval('sdsA_1_13_1', 'tableDatasv', 0);
            } else {
                this.changetableval('sdsA_1_13_1', 'tableDatasv', total);
            }
        },
        getsdsA_3_1000_3() {
            let total = 0;
            let all = this.filternums(this.tableDatavx, this.IIIHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 6) == 'sdsA_3' && item.cellCode.substring(9, 10) == '3') {
                    total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                }
            });
            this.changetableval('sdsA_3_1000_3', 'tableDatavx', total);
        },
        getsdsA_3_1000_4() {
            let total = 0;
            let all = this.filternums(this.tableDatavx, this.IIIHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 6) == 'sdsA_3' && item.cellCode.substring(9, 10) == '4') {
                    total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                }
            });
            this.changetableval('sdsA_3_1000_4', 'tableDatavx', total);
        },
        getsdsA_3_1000_5() {
            let total = 0;
            let all = this.filternums(this.tableDatavx, this.IIIHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 6) == 'sdsA_3' && item.cellCode.substring(9, 10) == '5') {
                    total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                }
            });
            this.changetableval('sdsA_3_1000_5', 'tableDatavx', total);
        },
        getsdsA_3_1000_6() {
            let total = 0;
            let all = this.filternums(this.tableDatavx, this.IIIHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 6) == 'sdsA_3' && item.cellCode.substring(9, 10) == '6') {
                    total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                }
            });
            this.changetableval('sdsA_3_1000_6', 'tableDatavx', total, '', 10);
        },
        getsdsA_3_1000_9() {
            let total = 0;
            let all = this.filternums(this.tableDatavx, this.IIIHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 6) == 'sdsA_3' && item.cellCode.substring(9, 10) == '9') {
                    total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                }
            });
            this.changetableval('sdsA_3_1000_9', 'tableDatavx', total);
        },
        getsdsA_3_1000_10() {
            let total = 0;
            let all = this.filternums(this.tableDatavx, this.IIIHead);
            all.forEach((item) => {
                if (item.cellCode.substring(0, 6) == 'sdsA_3' && item.cellCode.substring(9, 11) == '10') {
                    total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                }
            });
            this.changetableval('sdsA_3_1000_10', 'tableDatavx', total);
        },
        gettableval(changecode, table, old) {
            var head = '';
            if (
                table == 'tableDataI' ||
                table == 'tableDatas' ||
                table == 'tableDatasv' ||
                table == 'tableDatasvi' ||
                table == 'tableDatasvii'
            ) {
                head = 'IHead';
            }
            if (table == 'tableDataIII' || table == 'tableDatavx') {
                head = 'IIIHead';
            }
            if (table == 'tableDataII') {
                head = 'IIHead';
            }
            var a;
            if (this[table] && this[head]) {
                for (let i = 0; i < this[table].length; i++) {
                    for (let j = 0; j < this[head].length; j++) {
                        if (
                            this[table][i][this[head][j]] &&
                            this[table][i][this[head][j]].cellCode &&
                            this[table][i][this[head][j]].cellVal &&
                            this[table][i][this[head][j]].cellCode == changecode
                        ) {
                            if (old) {
                                if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
                                    a = 0;
                                } else {
                                    a = parseFloat(this[table][i][this[head][j]].goujgxValue);
                                }
                            } else {
                                if (this[table][i][this[head][j]].cellVal == '-') {
                                    a = 0;
                                } else {
									if (changecode=='sdsA_1_0d_1'||changecode=='sdsA_1_0e_1') {
											 a = this[table][i][this[head][j]].cellVal || 0;
									}else{
										 a = parseFloat(this[table][i][this[head][j]].cellVal || 0);
									}
                                   
                                }
                            }
                            break;
                        }
                    }
                }
            }
            a = a || 0;
            if (
                changecode == 'sdsA_1_18_1' ||
                changecode == 'sdsA_1_19_1' ||
                changecode == 'sdsA_1_20_1' ||
                changecode == 'sdsA_1_20_2' ||
                changecode == 'sdsA_1_23.2_2'
            ) {
                if (!a < 1) {
                    if( changecode == 'sdsA_1_20_2'){
                        a = this.toFixed(a * 0.01,12) ;
                    }else{
                        a = a * 0.01;
                    }
                }
            }
            return a;
        },
        changetableval(changecode, table, newval, checkq, digit) {
			console.log(changecode)
			console.log(table)
			console.log(newval)
			
            var newval = newval || 0;
			
            if (digit) {
                newval = this.toFixed(newval, digit);
            } else{
				newval = this.toFixed(newval, 2);
			}
			console.log(123123)
            var head = '';
            if (
                table == 'tableDataI' ||
                table == 'tableDatas' ||
                table == 'tableDatasv' ||
                table == 'tableDatasvi' ||
                table == 'tableDatasvii'
            ) {
                head = 'IHead';
            }
            if (table == 'tableDataIII' || table == 'tableDatavx') {
                head = 'IIIHead';
            }
            if (table == 'tableDataII') {
                head = 'IIHead';
            }
			
            for (let i = 0; i < this[table].length; i++) {
                for (let j = 0; j < this[head].length; j++) {
                    if (
                        this[table][i][this[head][j]] &&
                        this[table][i][this[head][j]].cellCode &&
                        typeof this[table][i][this[head][j]].cellVal != 'undefined' &&
                        typeof this[table][i][this[head][j]].cellVal != undefined &&
                        this[table][i][this[head][j]].cellCode == changecode
                    ) {
                        if (this[table][i][this[head][j]].cellVal != newval) {
                            if (this.suosq.substring(4, 6) < 5 && checkq) {
                                this[table][i][this[head][j]].cellVal = '';
                            } else {
                                this[table][i][this[head][j]].cellVal = newval + '';
                            }
                            this.inputblur({
                                cellCode: changecode,
                                cellVal: newval
                            });
                            break;
                        }
                    }
                }
            }
        }
    }
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
